export const CSS = {
  sticky: "sticky-pos",
};

export enum ICON_TYPES {
  circle = "circle",
  square = "square",
  grip = "grip",
}
export const TEXT = {
  filterResults: "Filter results",
};

export const SLOTS = {
  menuActions: "menu-actions",
};
